export default __webpack_public_path__ + "static/media/slider2.bbc82ea8.jpg";